import { Image } from '@mantine/core';
import classes from './SideMenuHeader.module.css';

export function SideMenuHeader() {
  return (
    <div className={classes.header}>
      <Image
        mah={100}
        src="/assets/logo/washday_logo.webp" // WebP (primary)
        fallbackSrc="/assets/logo/washday_logo.png" // PNG si no carga WebP
        alt="Washday Logo"
        loading="eager" // para que no espere a lazy-load
        fetchPriority="high" // Chrome 108+ da más peso al preload
      />
    </div>
  );
}
